@let current = step();

<button
  type="button"
  class="step-row"
  [class.step-row--completed]="current.completed"
  [class.step-row--locked]="current.locked"
  [attr.aria-label]="ariaLabel(current)"
  [disabled]="current.locked"
  (click)="onClick()"
>
  <span class="step-row__left">
    <umss-icon
      [name]="current.locked ? 'phosphorLock' : current.iconName"
      size="20px"
      [color]="
        current.locked
          ? 'var(--neutral-400)'
          : current.completed
            ? 'var(--green-500)'
            : 'var(--color-Secondary)'
      "
    />
    <span class="step-row__text">
      <span
        class="step-row__label"
        [class.step-row__label--completed]="current.completed"
        [class.step-row__label--locked]="current.locked"
      >
        {{ current.label }}
      </span>
      @if (current.locked && current.lockedHint) {
        <span class="step-row__hint">{{ current.lockedHint }}</span>
      }
    </span>
  </span>

  <span class="step-row__right">
    @if (current.completed) {
      <umss-icon
        name="phosphorCheckCircle"
        size="20px"
        color="var(--green-500)"
      />
    } @else if (!current.locked) {
      <umss-icon
        name="phosphorArrowRight"
        size="20px"
        color="var(--color-Secondary)"
      />
    }
    <!-- Locked rows show no trailing icon; the greyed row carries the state. -->
  </span>
</button>
